import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import { setAlert } from 'src/store/actions/alertActions';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { text } from "../../modules/languages/index";
const useStyles = makeStyles((theme) => ({
  root: {},
  summaryButton: {
    backgroundColor: theme.palette.common.black
  },
  barChartIcon: {
    marginRight: theme.spacing(1)
  },
  image: {
    width: '100%',
    maxHeight: 400
  }
}));

function Header({ className, AtananIsler, handleRefresh, setAlert, ...rest }) {
  const classes = useStyles();

  const SessionUser = getUser();

  let TeknAdet = 0;

  if (Array.isArray(AtananIsler) && AtananIsler.length > 0) {
    const TeknisyendeData = AtananIsler.filter(
      d => Number(d?.DurumKodu) === 21
    );
    TeknAdet = TeknisyendeData.length;
  }



  const assignAllJob = () => {
    if (TeknAdet === 0)
      return;
    confirmAlert({
      message: "Tüm işlerinizi üstlenmek istiyor musunuz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => { assignAllJobYes() }
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });

  }

  const assignAllJobYes = () => {
    axios.get(`/AssignAllJobs/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`)
      .then(res => {
        setAlert(res.data);
        handleRefresh();
      })
  }

  return (
    <div  {...rest} className={clsx(classes.root, className)}>
      <Grid
        alignItems="center"
        container
        justifyContent="space-between"

        spacing={3}
      >
        <Grid
          item
          md={6}
          xs={12}
        >
          <Typography
            component="h5"
            gutterBottom
            variant="h3"
            style={{ fontFamily: 'Arcelik', fontWeight: 'bold' }}
          >
            {text("iyi_gunler")},
            {' '}
            {SessionUser.FirstName} {SessionUser.LastName}

          </Typography>
          <Typography
            gutterBottom
            variant="subtitle1"
            style={{ fontFamily: 'Arcelik', fontWeight: 'normal' }}
            onClick={() => assignAllJob()}
          >
            {
              (TeknAdet === 0)
                ? <div></div>
                : <div>
                  {text("isler_header").replace("#$TeknAdet$#", TeknAdet)}
                </div>
            }
          </Typography>
        </Grid>
      </Grid>

    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default connect(
  null,
  { setAlert }
)(Header);
